import axiosInstance from "./axios";
import { ReportRow } from "./models/report.models";

import {
  CreateReportRowPayload,
  UpdateReportRowPayload,
} from "./models/reportRow.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const updateReportRow = async (
  companyId: number,
  payload: UpdateReportRowPayload,
  bearerToken?: string
): Promise<ReportRow> => {
  try {
    const response = await axiosInstance.put(
      `${apiUrl}/Report/reports/${companyId}/${payload.reportId}/rows${payload.organizationId ? `?organizationId=${payload.organizationId}` : ""}`,
      {
        ...payload,
        reportId: undefined, // Remove reportId from the payload
      },
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update report:", error);
    throw error;
  }
};

export const createReportRow = async (
  companyId: number,
  payload: CreateReportRowPayload,
  bearerToken?: string
): Promise<ReportRow> => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/Report/reports/${companyId}/${payload.reportId}/rows${payload.organizationId ? `?organizationId=${payload.organizationId}` : ""}`,
      {
        ...payload,
        reportId: undefined, // Remove reportId from the payload
      },
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create report:", error);
    throw error;
  }
};

export const deleteReportRow = async (
  companyId: number,
  rowId: number,
  organizationId?: number,
  bearerToken?: string
): Promise<void> => {
  try {
    await axiosInstance.delete(
      `${apiUrl}/Report/reports/${companyId}/rows/${rowId}${organizationId ? `?organizationId=${organizationId}` : ""}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
  } catch (error) {
    console.error("Failed to delete report row:", error);
    throw error;
  }
};
